import Home from '../pages/Home.vue'
import Login from '../pages/Login.vue'

const Admin = () => import('../pages/Admin.vue')
const Favorites = () => import('../pages/Favorites/index.vue')
const BatchCutout = () => import('../pages/BatchCutout/index.vue')
const BatchCutoutEdit = () => import('@/pages/BatchCutout/Edit.vue')
const Navigation = () => import('@/pages/Navigation/index.vue')
const speechSynthesis = () => import('@/pages/SpeechSynthesis/index.vue')
const BatchNovels = () => import('@/pages/BatchNovels/index.vue')
const Workflow = () => import('@/pages/Workflow/index.vue')
const ConvertVideo = () => import('../pages/Convert/index.vue')
const GetMaterials = () => import('@/pages/GetMaterials/index.vue')
const TaskStatistics = () => import('../pages/TaskStatistics/index.vue')
const ImageAIGenerator = () => import('../pages/ImageAIGenerator/index.vue')
const JingDong = () => import('../pages/JingDong/index.vue')
const BatchShortPlay = () => import('@/pages/BatchShortPlay/index.vue')

const routes = [
  {
    name: 'Home',
    path: '/',
    component: Home,
    meta: {
      title: 'Home'
    }
  },
  {
    name: 'Admin',
    path: '/admin',
    component: Admin,
    meta: {
      title: 'Admin'
    }
  },
  {
    name: 'Login',
    path: '/login',
    component: Login,
    meta: {
      title: 'Login'
    }
  },
  { name: 'favorites', path: '/favorites', component: Favorites, meta: { title: 'Favorites' } },
  {
    name: 'batchCutout',
    path: '/batchCutout',
    component: BatchCutout,
    meta: { title: 'BatchCutout' }
  },
  {
    path: '/batch-cutout/edit',
    name: 'BatchCutoutEdit',
    component: BatchCutoutEdit,
    props: true
  },
  {
    path: '/navigation',
    name: 'navigation',
    component: Navigation,
    props: true
  },
  {
    path: '/speechSynthesis',
    name: 'speechSynthesis',
    component: speechSynthesis,
    props: true
  },
  {
    path: '/batchNovels',
    name: 'batchNovels',
    component: BatchNovels,
    props: true
  },
  {
    path: '/workflow',
    name: 'workflow',
    component: Workflow,
    props: true
  },
  {
    path: '/image-ai-generator',
    name: 'imageAIGenerator',
    component: ImageAIGenerator,
    props: true
  },
  {
    path: '/video-color-cvt',
    name: 'convertVideo',
    component: ConvertVideo,
  },
  {
	path: '/get-materials',
	name: 'getMaterials',
	component: GetMaterials
  },
  {
    path: '/task-statistics',
    name: 'taskStatistics',
    component: TaskStatistics,
  },
  {
    path: '/JD_Improve',
    name: 'jingDong',
    component: JingDong,
  },
  {
    path: '/batchShortPlay',
    name: 'batchShortPlay',
    component: BatchShortPlay,
    props: true
  },
]

export default routes
